import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';
import ColorPicker from 'components/form/ColorPicker';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import UploadIcon from '@mui/icons-material/Upload';
import EditIcon from '@mui/icons-material/Edit';
import CloseIcon from '@mui/icons-material/Close';
import Files from 'modules/files';
import Stack from '@mui/material/Stack';
import styled from '@mui/material/styles/styled';
import Switch from 'components/form/Switch';
import Button from 'components/Button';
import IconButton from 'components/IconButton';
import { BUCKET_URL } from 'constants/index';

const LogoStyled = styled('div')`
  display: flex;
  align-items: center;
  width: 200px;
  height: 60px;

  img {
    width: auto;
    max-width: 70%;
    height: auto;
    max-height: 100%;
    object-fit: contain;
    margin-right: 16px;
    flex: 1;
  }
`;

const BasicDetails = ({ value, onChange, onNext }) => {
  const [showFiles, setShowFiles] = useState(false);

  const { template_color } = value;

  const toggleFileBrowser = () => {
    setShowFiles(!showFiles);
  };

  const onFileSelect = (file) => {
    onChange('logo', file);
    toggleFileBrowser();
  };

  const onSwitchChange = (e) => {
    const { name, checked } = e.target;
    onChange(name, checked ? '1' : '0');
  };

  return (
    <Box mt={2}>
      <Typography gutterBottom fontWeight={500}>
        Page Design
      </Typography>
      <Paper variant="outlined" sx={{ p: 1, mb: 1 }}>
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
          mb={2}
        >
          <Typography>Primary Page Color</Typography>
          <ColorPicker
            size="small"
            value={template_color}
            onChange={(val) => onChange('template_color', val)}
          />
        </Stack>
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
        >
          <Typography>Logo</Typography>
          {value.logo ? (
            <Paper
              variant="outlined"
              sx={{ p: 1, display: 'flex', alignItems: 'center' }}
            >
              <LogoStyled>
                <img src={BUCKET_URL + value.logo.location} />
              </LogoStyled>
              <Stack direction="row" spacing={1}>
                <IconButton
                  onClick={() => onChange('logo', '')}
                  size="small"
                  color="error"
                  icon={<CloseIcon fontSize="small" />}
                />
                <IconButton
                  size="small"
                  color="primary"
                  icon={<EditIcon fontSize="small" />}
                  onClick={toggleFileBrowser}
                />
              </Stack>
            </Paper>
          ) : (
            <Button
              startIcon={<UploadIcon />}
              onClick={toggleFileBrowser}
              variant="outlined"
            >
              Upload
            </Button>
          )}
        </Stack>
      </Paper>
      <Box display="flex" alignItems="center" justifyContent="space-between">
        <Typography fontWeight={500}>Include reactions</Typography>
        <Switch
          margin="dense"
          size="small"
          name="is_message_reaction_enabled"
          checked={value.is_message_reaction_enabled === '1'}
          onChange={onSwitchChange}
        />
      </Box>
      <Box mb={3}>
        {showFiles && (
          <Dialog
            open
            fullWidth
            maxWidth="lg"
            onBackdropClick={toggleFileBrowser}
            onHide={toggleFileBrowser}
          >
            <DialogTitle>Select file</DialogTitle>
            <DialogContent>
              <Files
                filePicker
                onFileSelect={onFileSelect}
                accept={{
                  'image/*': ['.jpg', '.jpeg', '.png', '.gif'],
                }}
              />
            </DialogContent>
          </Dialog>
        )}
      </Box>
    </Box>
  );
};

export default BasicDetails;
